/* eslint-disable @typescript-eslint/no-explicit-any */

import { cn } from "@/lib/utils";
import { DocumentTableCell } from "./document-table-cell";

export const DocumentTable = ({ data, parentKey }: any) => {
  return (
    <div className="overflow-auto">
      <div className="table w-full">
        <div className="table-row">
          {Object.entries(data[0]).map(([key], index: number) => {
            return (
              <DocumentTableCell
                isHeader={true}
                key={index}
                data={key}
                keyValue={key}
              />
            );
          })}
        </div>
        {data.map((item: any, index: number) => {
          return (
            <div
              className={cn("table-row", index % 2 === 0 ? "" : "bg-gray-50")}
              key={index}
            >
              {Object.entries(item).map(([key, value], rowIndex: number) => {
                return (
                  <DocumentTableCell
                    data={value}
                    key={rowIndex}
                    keyValue={key}
                    parentKey={`${parentKey}.${index}.${key}`}
                  />
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};
